import { FileMetaData, parquetMetadataAsync } from "hyparquet";

import { Readable } from "../../fs";

export class ParquetMetadataReader {
  private sourceFileToMetadata: Map<string, FileMetaData> = new Map();
  metadataForSourceFile(
    source: Readable,
    signal?: AbortSignal,
  ): Promise<FileMetaData> {
    const cacheKey = source.id();
    if (this.sourceFileToMetadata.has(cacheKey)) {
      return Promise.resolve(this.sourceFileToMetadata.get(cacheKey)!);
    }
    return navigator.locks.request(
      `metadataForSourceFile#${cacheKey}`,
      { signal },
      async () => {
        signal?.throwIfAborted();

        if (this.sourceFileToMetadata.has(cacheKey)) {
          return this.sourceFileToMetadata.get(cacheKey)!;
        }

        const metadata = await parquetMetadataAsync({
          byteLength: Number(await source.size()),
          async slice(start: number, end: number) {
            const size = BigInt(end - start);
            const offset = BigInt(start);
            const view = await source.read(offset, size);
            return view.buffer as ArrayBuffer;
          },
        });
        this.sourceFileToMetadata.set(cacheKey, metadata);
        return metadata;
      },
    );
  }
}
